export default __webpack_public_path__ + "static/media/d-1.46638963.png";